import { reactive, watch } from '@vue/composition-api'

function getInnerValue(cast, values, innerSetting) {
  const hasValue = !!values && values.length > 0
  let innerValue
  if (cast === 'array') {
    innerValue = values.map(v => {
      const valueOption = innerSetting.ValueOptions.find(opt => opt.Value === v)
      return typeof valueOption !== 'undefined'
        ? valueOption
        : {
            Name: `Option is missing (${v})`,
            Value: v,
            isMissing: true,
          }
    })
  } else {
    innerValue = hasValue ? values[0] : null
  }
  if (cast === 'bool') {
    innerValue = innerValue === 'true' || innerValue === true
  }
  if (cast === 'int') {
    innerValue = parseInt(innerValue)
  }

  return innerValue
}

function ifSomeSelectedItemIsMissing(cast, values) {
  return cast === 'array' ? values.find(v => v.isMissing) : false
}

export default ({ props, cast, emit }) => {
  const innerSetting = props.setting
  const values = innerSetting.Values
  const temporaryInnerValue = ''

  const inheritValues =
    innerSetting.InheritedSetting?.Values !== null &&
    innerSetting.InheritedSetting?.Values !== undefined
      ? innerSetting.InheritedSetting.Values
      : []

  const inherit = !values || values.length === 0
  const innerValue = !inherit
    ? getInnerValue(cast, values, innerSetting)
    : getInnerValue(cast, inheritValues, innerSetting)
  let isSelectedItemIsMissing = false
  const inheritValue = getInnerValue(cast, inheritValues, innerSetting)
  const state = reactive({
    inherit,
    innerSetting,
    innerValue,
    inheritValue,
    temporaryInnerValue,
    isSelectedItemIsMissing,
  })
  if (emit && typeof emit === 'function') {
    watch([() => state.innerValue, () => state.inherit], ([newVal, newInherit]) => {
      const emptyValue = cast === 'array' ? [] : null
      const toEmit = newInherit ? emptyValue : newVal
      emit('change', toEmit)
    })
    //TODO: Refactor isSelectedItemIsMissing to computed property
    watch([() => state.innerValue], ([newVal]) => {
      state.isSelectedItemIsMissing = ifSomeSelectedItemIsMissing(cast, newVal)
    })
  } else console.error('emit is not a function for', innerSetting.SettingKey)
  return state
}
